<template>
    <div class="row" v-if="isFiche">
          <!-- Modern Icons Wizard -->
          <div class="col-12 mb-4">
            <div class="bs-stepper wizard-icons wizard-icons-example mt-2">
              
              <div class="row g-4" style="padding: 10px;">
                  <div class="col-sm-8">
                    <h2 class="card-header text-400" style="line-height: 40px;">FICHE DE PROSPECTION SOCIETE : <span class="text-primary"><u><b>{{ prospect.nom_societe }}</b></u></span> GESTIONNAIRE : <span class="text-primary"><u><b>{{ prospect.nom }} {{ prospect.prenoms}}</b></u></span> </h2>
                  </div>
                  <div class="col-sm-4 text-end">
                    <button @click="exportToPdf()"  type="button" class="btn btn-dark waves-effect waves-light mr-2"><span class="mdi mdi-file-download"></span> Telecharger la fiche</button>
                    <button @click="closeFiche()" type="button" class="btn btn-danger waves-effect waves-light">Annuler</button>
                  </div>
                </div>
              <div class="bs-stepper-content active">
                
                <form @submit="addProspect($event)">
                  <!-- Account Details -->
                  <div id="account-details-modern" :class="{'content' : true, 'active': true, 'dstepper-block' : true}">
                    <div class="row g-4 mb-4 align-items-center">
                      <div class="col-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Nom société</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.nom_societe" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Secteur d'activité</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.libelle_sector" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Effectif</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.effectif" disabled>
                        </div>
                      </div>
                    </div>
                    <div class="row g-4">
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">DG</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.dg" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Interlocuteur</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.interlocuteur" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Contact société</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.contact_societe" disabled>
                        </div>
                      </div>
                     <div class="row g-4">
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Date 1er contact</label>
                            <input id="defaultInput" class="form-control" type="text" :value="new Date(prospect.date_premier_contact).toLocaleDateString()" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Nature de la prospection</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.libelle_nature_prospection" disabled>
                        </div>
                      </div>
                      <div class="col-sm-4 text-center">
                        <label for="defaultInput" class="form-label">Intéresse</label>
                        <br>
                        <span class="badge bg-label-primary me-1" v-if="prospect.interesse=='oui'" style="text-transform: lowercase;">{{ prospect.interesse }}</span>
                        <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.interesse }}</span>
                      </div>
                     </div>
                     <hr  style="margin: 30px auto;  border: 1px solid #7a7a7a; width: 100%;">
                     <div class="row g-4">
                        <div class="col-sm-4">
                            <div class="mb-3">
                            <label for="defaultInput" class="form-label">Garantie</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.libelle_garantie" disabled>
                        </div>
                        </div>
                      <div class="col-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Type contrat</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.type_contrat" disabled>
                        </div>
                      </div>
                      <div class="col-4 text-center">
                        <label for="defaultInput" class="form-label">Liste pour cotation</label>
                        <br>
                        <span class="badge bg-label-primary me-1" v-if="prospect.liste_cotation=='oui'" style="text-transform: lowercase;">{{ prospect.liste_cotation }}</span>
                        <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.liste_cotation }}</span>
                      </div>
                      <div class="col-4 text-center">
                        <label for="defaultInput" class="form-label">Offre commerciale</label>
                        <br>
                        <span class="badge bg-label-primary me-1" v-if="prospect.offre_commerciale=='oui'" style="text-transform: lowercase;">{{ prospect.offre_commerciale }}</span>
                        <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.offre_commerciale }}</span>
                      </div>
                      <div class="col-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Prévision annuelle</label>
                            <input id="defaultInput" class="form-control" type="text" :value="prospect.prevision_annuelle" disabled>
                        </div>
                      </div>
                      <div class="col-4 text-center">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Projet convention</label>
                            <br>
                            <span class="badge bg-label-primary me-1" v-if="prospect.projet_convention=='oui'" style="text-transform: lowercase;">{{ prospect.projet_convention }}</span>
                            <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.projet_convention }}</span>
                        </div>
                      </div>
                     </div>
                    </div>
                  </div>
                  <hr  style="margin: 30px auto;  border: 1px solid #7a7a7a; width: 100%;">
                  <!-- Personal Info -->
                  <div id="personal-info-modern" :class="{'content' : true, 'active': true, 'dstepper-block' : true}">
                    <div class="row g-4">
                      <div class="col-sm-4 text-center">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Validation projet</label>
                            <br>
                            <span class="badge bg-label-primary me-1" v-if="prospect.validation_projet=='oui'" style="text-transform: lowercase;">{{ prospect.validation_projet }}</span>
                            <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.validation_projet }}</span>
                        </div>
                      </div>
                      <div class="col-sm-4 text-center">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Signature</label>
                            <br>
                            <span class="badge bg-label-primary me-1" v-if="prospect.validation_projet=='oui'" style="text-transform: lowercase;">{{ prospect.signature }}</span>
                            <span class="badge bg-label-danger me-1" v-else style="text-transform: lowercase;">{{ prospect.signature }}</span>
                        </div>
                      </div>
                      <div class="col-sm-4">
                        <div class="mb-3">
                            <label for="defaultInput" class="form-label">Dernier contact</label>
                            <input id="defaultInput" class="form-control" type="text" :value="new Date(prospect.dernier_contact).toLocaleDateString()" disabled>
                        </div>
                      </div>
                      <div class="col-sm-12">
                          <label for="selectpickerBasic">Règlement</label>
                          <textarea v-model="prospect.reglements"  class="form-control" placeholder="Observation" aria-label="Observation" aria-describedby="basic-icon-default-message2" disabled></textarea>
                        </div>
                        <div class="col-sm-12">
                          <label for="selectpickerBasic">Observation</label>
                          <textarea v-model="prospect.observations"  class="form-control" placeholder="Observation" aria-label="Observation" aria-describedby="basic-icon-default-message2" disabled></textarea>
                        </div>
                      
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>

          
          
        </div>
</template>

<script>
import Calendar from 'primevue/calendar';

import "vue-toastification/dist/index.css";
import { useToast } from "vue-toastification";
import VueHtml2pdf from 'vue-html2pdf'

const toast = useToast();

export default {
  name: 'AjoutProspect',
  components : {
      Calendar, VueHtml2pdf
  },
  props: {
      isFiche : Boolean,
      
      prospect : Object
  },
  data() {
      return {
          step_one : true,
          step_two : false,
          step_three : false,
          
      }
  },
  mounted(){
      
  },
  computed : {
        toNext(){
         return this.prospect.id_admin == '' || this.prospect.nom_societe == '' || 
         this.prospect.date == '' || this.prospect.id_sector == '' || this.prospect.effectif == '' ||
         this.prospect.dg == '' || this.prospect.drh == '' || this.prospect.interlocuteur == '' || 
         this.prospect.contact_societe == '' || this.prospect.id_nature_prospection == '' || this.prospect.interesse == ''
        }
    },
  methods : {
      closeFiche(){
          this.$emit('closeFiche')
      },
      async addProspect(e){
          e.preventDefault()
          const datas = new FormData()
              for(const objet in this.prospect){
                datas.append(objet, this.prospect[objet])
              }
              let response = await this.$axios.post('prospect/add', datas);
                if(response.data.code ==400){
                    toast.error(response.data.message)
                    return
                }
                
                toast.success(response.data.message)
              this.resetDatas()
            this.$emit('AjoutProspect')
      },
      goStepTwo(){
          this.step_one = false
          this.step_two = true
      },
      prevStepOne(){
          this.step_one = true
          this.step_two = false
      },
      resetDatas(){
        return
      },
      exportToPDF() {
        // this.$refs.html2Pdf.generatePdf()
		},
  },
  beforeMount(){
      
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.btn-danger{
/* float: right !important; */
/* margin-bottom: 20px; */
}
.light-style .bs-stepper.wizard-modern {
background-color: transparent;
}
.text-primary{
    color: #ce9c2b !important;
}
</style>
